import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { compose } from 'redux';
import cx from 'classnames';
import AddProfilePopup from './AddProfilePopup';
import s from './SafeTechPopup.css';

class SafeTechPopup extends React.Component {
  render() {
    return (
      <div>
        <AddProfilePopup
           onClose={this.props.onClose}
           serial={this.props.serial}
           nextProfile={this.props.nextProfile}
        />
      </div>
    );
  }
}

SafeTechPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  serial: PropTypes.string.isRequired,
  nextProfile: PropTypes.number.isRequired,
};

const mapState = state => ({
});

const mapDispatch = dispatch => {
  return {
  };
};

export default injectIntl(
  compose(withStyles(s), connect(mapState, mapDispatch))(SafeTechPopup)
);



// WEBPACK FOOTER //
// ./src/components/SafeTechPopup/SafeTechPopup.js